module.exports = __webpack_public_path__ + "static/media/AB_RL4_2.32bf6926.jpg";